import { useMemo } from "react";
import { Form } from "antd";
import type { FormInstance } from "antd";
import { HomePhoneShippingDetails } from "../../../../../types/homePhone";
import SHIPPING_FORM from "../constants";

interface UseShippingFormOptions {
  initialValues?: HomePhoneShippingDetails | null;
}

interface UseShippingFormResult {
  form: FormInstance<HomePhoneShippingDetails>;
  formInitialValues: Partial<HomePhoneShippingDetails>;
}

const useShippingForm = ({
  initialValues,
}: UseShippingFormOptions): UseShippingFormResult => {
  const [form] = Form.useForm<HomePhoneShippingDetails>();

  const formInitialValues = useMemo<Partial<HomePhoneShippingDetails>>(
    () => ({ country: SHIPPING_FORM.DEFAULT_COUNTRY, ...(initialValues ?? {}) }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
    // Intentionally empty: initial values must only be read on first mount.
    // Re-running when initialValues changes would overwrite the user's in-progress edits.
  );

  return { form, formInitialValues };
};

export default useShippingForm;
